function RequiredAsterisk() {
  return <span aria-hidden="true">*</span>;
}

export default RequiredAsterisk;
